import React from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarCompletedMark, CalendarPlannedMark } from './CalendarCompletedMark';
import './CalendarStatusLegend.css';

export function CalendarStatusLegend() {
  const { t } = useTranslation();
  return <ul className="calendar-status-legend">
    <li><CalendarCompletedMark /><span>{t('calendarWorkoutStatus.done')}</span></li>
    <li><CalendarPlannedMark /><span>{t('calendar.workoutCard.tssPlanned')}</span></li>
    <li><CalendarPlannedMark missed /><span>{t('calendarWorkoutStatus.missed')}</span></li>
  </ul>;
}
